export default function formatTotalNumberShort(getNum) {
    const num = parseFloat(getNum)
    if (num < 1000) {
        return num.toString();
    } else if (num < 1000000) {
        return (num / 1000).toFixed(1) + 'k';
    } else {
        return (num / 1000000).toFixed(1) + 'm';
    }
}